{ get_from_list } = require '../../utils'
companySuffixes = require './CompanySuffixes'
latinScriptCountries = require './LatinScriptCountries'
latinScriptLanguages = require './LatinScriptLanguages'
_ = require('lodash')

module.exports = ($scope, $stateParams, $uibModal, Api, User) ->
  $scope.doesWorkflowTemplateSupportSiteSearch = (workflow) ->
    if !workflow
      return false
    template = get_from_list($scope.workflowTemplates, workflow)
    return template and template.steps_supporting_site_search_count > 0

  $scope.doesWorkflowTemplateSupportAdverseTerms = (workflow) ->
    if !workflow
      return true
    template = get_from_list($scope.workflowTemplates, workflow)
    return template and template.steps_supporting_adverse_terms_count > 0

  $scope.doesWorkflowTemplateSupportCountry = (workflow) ->
    if !workflow
      return true
    template = get_from_list($scope.workflowTemplates, workflow)
    return template and (template.step_count > template.steps_supporting_global_count)

  $scope.resetCountries = (w) ->
    if $scope.doesWorkflowTemplateSupportCountry(w.template)
      return

    for name in w.simple_names
      name.country = undefined

  $scope.resetAdverseTerms = (w) ->
    if $scope.doesWorkflowTemplateSupportAdverseTerms(w.template)
      return

    for name in w.simple_names
      name.adverse_terms_id = undefined

  $scope.resetSiteSearch = (w) ->
    if $scope.doesWorkflowTemplateSupportSiteSearch(w.template)
      return
    w.site = site: ""

  # `resetFields` is called when a new workflow is selected.
  # It is called to ensure that any fields that depends on certain workflow
  # conditions to be met are updated accordingly.
  # e.g. The adverse terms model should reset if a new workflow is selected
  #      that does not support adverse terms.
  $scope.resetFields = (w) ->
    $scope.resetCountries(w)
    $scope.resetAdverseTerms(w)
    $scope.resetSiteSearch(w)

  $scope.selectDefaultWorkflowTemplate = () ->
    defaultWorkflowId = User.defaultWorkflowId()
    if $scope.w and $scope.workflowTemplates and !$scope.w.template
      # The reason to look in the list of filteredWorkflowTemplates is that it is possible the user does not have
      # permission to see the workflow that has been set as the default.
      if defaultWorkflowId and _.find($scope.filterWorkflowTemplates($scope.w), {id: defaultWorkflowId})
        $scope.w.template = defaultWorkflowId
      else
        $scope.w.template = null

  $scope.selectDefaultWorkflowCountry = () ->
    # Set the workflow country if the user is configured with a default one and the workflow country is not already set.
    # This function is called when editing an existing project so a different country may already be set.
    if $scope.w and $scope.countries and !$scope.w.countries[0]
      $scope.w.countries[0] = User.defaultWorkflowCountryId()

  $scope.filterWorkflowTemplates = (workflow) ->
    $scope.workflowTemplates.filter (template) ->
      workflow.entity_type is null or template.entity_type is null or template.entity_type == workflow.entity_type

  $scope.findRelatedProjects = (simple_name) ->
    if simple_name?.name?.length > 2 and simple_name.oldNameValue != simple_name.name
      limit = 100
      Api.ProjectPagination.query({name: simple_name.name, limit: limit, archived: false}).$promise.then (response) ->
        if response.results.length
          response.count = String(response.results.length)
          if response.next
            response.count += "+"
        else
          response.count = undefined
        simple_name.relatedProjects = response
    else
      delete simple_name.relatedProjects

  $scope.hasCompanyEntity = (name) ->
    if not name
      return
    name = name.split(' ')
    if name.length < 2
      return
    else
      return true if name.pop().toLowerCase().replace(/\.|\//g, '') in companySuffixes

  $scope.nonLatinScriptCountry = (countryIsoCode) ->
    if latinScriptCountries.indexOf(countryIsoCode) == -1 and countryIsoCode
      true
    else
      false

  $scope.getCountryIsoCode = (countryId) ->
    if countryId
      (c.iso_code for c in $scope.countries when c.id == countryId)[0]

  $scope.containsNonLatinCharacters = (string) ->
    /[^\u0000-\u00ff]/.test string

  $scope.nonLatinScriptLanguage = (languageIsoCode) ->
    if latinScriptLanguages.indexOf(languageIsoCode) == -1 and languageIsoCode
      true
    else
      false

  $scope.getAdverseTermsLanguage = (adverseTermsId) ->
    if adverseTermsId
      (l.language.iso_code for l in $scope.adverseTermsLists when l.id == adverseTermsId and l.language?)[0]

  $scope.groupLanguage = (item) ->
    if not item.id
      return ''
    $scope.languagesPartitioned?[item.language?.id]?[0].name or 'Other'

  $scope.addNameVariations = (workflow) ->
    workflow.simple_names.push(
      'name': ''
      'adverse_terms_id': null
      'country': null
      'new': true
    )

  $scope.removeNameVariations = (idx, workflow) ->
    workflow.simple_names.splice(idx, 1)

  $scope.translateName = (name) ->
    languages = Api.Language.query().$promise
    translateModalInstance = $uibModal.open
      template: require("../../directives/TranslateModal/translate-modal.html")
      controller: "TranslateModalController"
      resolve:
        name: () ->
          return name
        languages: () ->
          return languages
    translateModalInstance.result.then (translation) ->
      $scope.w.simple_names.push({'name': translation, 'is_translated': "true", 'adverse_terms_id': null, 'country': null, 'new': true})

  $scope.isTemplateValidForEntityType = (workflow) ->
    if not $scope.workflowTemplates
      return true
    template = get_from_list($scope.workflowTemplates, workflow.template)
    return template is null or
      template is undefined or
      template.entity_type is null or
      workflow.entity_type is null or
      template.entity_type == workflow.entity_type

  $scope.setEntityType = (workflow, entity_type) ->
    workflow.entity_type = entity_type
    if not $scope.isTemplateValidForEntityType(workflow)
      workflow.template = null

  $scope.isIndividual = (workflow) ->
    workflow.entity_type == 'individual_name'

  $scope.removeBadTemplate = ->
    if not $scope.isTemplateValidForEntityType($scope.w)
      $scope.w.template = null

  $scope.onSubjectInputBlur = (workflow, simple_name) ->
    $scope.findRelatedProjects(simple_name)

  $scope.onSubjectInputFocus = (workflow, simple_name) ->
    simple_name.oldNameValue = simple_name.name

  $scope.limitItemsInDropdown = ->
    $scope.itemsLimit = $scope.itemsDropdownLimit

  $scope.itemsLimit = 1000
  $scope.itemsDropdownLimit = 20
  $scope.selectDefaultWorkflowTemplate()
  $scope.removeBadTemplate()

  $scope.loadStateParams = ($stateParams) ->
    # The $stateParams come from the `$state.go('project-new'` in
    # ReportsController.coffee; the stateParams are the params passed for
    # the state transition in the state machine and bring the details that
    # the user typed in the quick create workflow form.
    # Note stateParams only accepts the fields specified in config.coffee
    # for the project_new state.
    if not $stateParams or not $scope.w
      return

    $scope.w.simple_names[0].name = $stateParams.name or $scope.w.simple_names[0].name
    $scope.w.template = Number($stateParams.template) or $scope.w.template
    $scope.w.entity_type = $stateParams.entity_type or $scope.w.entity_type

    if $scope.doesWorkflowTemplateSupportCountry($scope.w.template)
      $scope.w.countries[0] = Number($stateParams.country) or $scope.w.countries[0]
      $scope.selectDefaultWorkflowCountry()

    if $scope.doesWorkflowTemplateSupportAdverseTerms($scope.w.template)
      $scope.w.simple_names[0].adverse_terms_id = Number($stateParams.adverse_terms_id) or $scope.w.simple_names[0].adverse_terms_id

  $scope.loadStateParams($stateParams)
